export default __webpack_public_path__ + "media/components/AdEdit/images/tm-promo-logo-7834e3ba656ea12452cb0da7042991a6.png";